<template>
  <!-- 分组 -->
  <div class="box-main">
    <div class="main">
      <div>
        <div class="main-title">
          <img
            class="arrow-left"
            src="../../../assets/img/arrow-left.svg"
            alt=""
            @click="pushBack"
          />
          <span class="ml20">{{ groupName }}</span>
        </div>
      </div>
      <v-row class="tabs-demo__size">
        <v-col :span="22">
          <v-tabs v-model="activeName" size="S" name="tabs-s-card" type="card">
            <v-tab-pane label="设备列表" value="1">
              <DeviceList :groupId="groupId"></DeviceList>
            </v-tab-pane>
          </v-tabs>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
// import GroupInfo from "@/components/group/group-info.vue";
import DeviceList from "@/components/group/device-list.vue";

export default {
  components: { DeviceList },
  data() {
    return {
      activeName: "",
      groupId: "",
    };
  },
  created() {
    this.groupId = this.$route.query.id;
    this.groupName = this.$route.query.name;
  },
  methods: {
    pushBack() {
      this.$router.push({ name: "/deviceInfo-manage/subgroup-list-info" });
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss">
</style>
